import Button from "@mui/material/Button";
import clsx from "clsx";

import styles from "./button.module.scss";

const MainButton = ({
  color,
  variant,
  onClick,
  disabled,
  children,
  className,
  autoFocus,
  startIcon,
  type = "button",
}) => {
  return (
    <Button
      type={type}
      color={color}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
      autoFocus={autoFocus}
      className={clsx(styles.btn, className)}
    >
      {children}
    </Button>
  );
};
export default MainButton;
